import NoteEvent from "./NoteEvent";
export default class HoldEvent extends NoteEvent {
    constructor() {
        super(...arguments);
        this._TIME_END = 0;
        this._TIME_LENGTH = 0;
        this._BEAT_END = 0;
        this._BEAT_LENGTH = 0;
    }
    get TIME_LENGTH() {
        return this._TIME_LENGTH;
    }
    set TIME_LENGTH(val) {
        this._TIME_LENGTH = val;
        this._TIME_END = this.TIME + val;
    }
    get TIME_END() {
        return this._TIME_END;
    }
    set TIME_END(val) {
        this._TIME_END = val;
        this._TIME_LENGTH = this._TIME_END - this.TIME;
    }
    get BEAT_LENGTH() {
        return this._BEAT_LENGTH;
    }
    set BEAT_LENGTH(val) {
        this._BEAT_LENGTH = val;
        this._BEAT_END = this.BEAT + val;
    }
    get BEAT_END() {
        return this._BEAT_END;
    }
    set BEAT_END(val) {
        this._BEAT_END = val;
        this._BEAT_LENGTH = this._BEAT_END - this.BEAT;
    }
}
